export default __webpack_public_path__ + "static/media/image.3aa18c36.svg";